import PageHeader from 'components/PageHeader'
import React from 'react'
import AddRoleData from './AddRoleData'

const AddRole = () => {
  return (
    <div className="dashboard-container">
      <PageHeader title="Add Role" hideFilter hideCalendar/>
      <AddRoleData />
    </div>
  )
}

export default AddRole